import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import type { SearchResultData } from '@/types/api';

export function useSearch(query: string) {
  return useQuery({
    queryKey: ['search', query],
    enabled: query.trim().length > 0,
    queryFn: async (): Promise<SearchResultData[]> => {
      const { data } = await api.get<SearchResultData[]>('/v1/search', {
        params: { q: query },
      });
      return data;
    },
    staleTime: 30_000,
  });
}

export function useDebouncedValue<T>(value: T, ms = 200): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = window.setTimeout(() => setDebounced(value), ms);
    return () => window.clearTimeout(t);
  }, [value, ms]);
  return debounced;
}

// React imports kept down here so the hook file stays focused.
import { useEffect, useState } from 'react';
